import React from "react";
import ViewUsers from "../component/Users/ViewUsers";

const Users = () => {
  return (
    <>
      <ViewUsers />
    </>
  );
};

export default Users;
